// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"PostTags-module--tag-container--ksSgQ"};